"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addWeeks;

function addWeeks(date, weeks) {
  var clone = new Date(date);
  clone.setDate(date.getDate() + weeks * 7);
  return clone;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/WeeklyCalendar/helpers/addWeeks.js
// module id = Rjv0
// module chunks = 0